export default class DialogType {
  constructor({ typeDialog, message, scroll }) {
    this.type = 'dialog';
    this.typeDialog = typeDialog;
    this.message = message;
    this.scroll = scroll;
  }
}
